import { render, staticRenderFns } from "./modalDelete.vue?vue&type=template&id=61a6112a"
import script from "./modalDelete.vue?vue&type=script&lang=js"
export * from "./modalDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports